// extracted by mini-css-extract-plugin
module.exports = {"footer":"_GZXJVc2r"};